import React from 'react';
import './LoadingSpinner.scss';

interface LoadingSpinnerProps {
  size?: 'small' | 'medium' | 'large';
  text?: string;
  fullScreen?: boolean;
}

const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({ 
  size = 'medium', 
  text,
  fullScreen = false 
}) => {
  const containerClass = fullScreen ? 'loading-spinner-fullscreen' : 'loading-spinner-container';
  
  return (
    <div className={containerClass}>
      <div className={`loading-spinner ${size}`}>
        <div className="spinner-ring">
          <div className="spinner-ring-inner"></div>
        </div>
        <div className="spinner-logo">
          <svg viewBox="0 0 40 40" className="logo-icon">
            <circle 
              cx="20" 
              cy="20" 
              r="12" 
              fill="none" 
              stroke="currentColor" 
              strokeWidth="2"
              strokeDasharray="75.4"
              strokeDashoffset="37.7"
              strokeLinecap="round"
            />
          </svg>
        </div>
      </div>
      {text && <p className="loading-text">{text}</p>}
    </div>
  );
};

export default LoadingSpinner;
